import { Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'

const CodePage = () => {
  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{
        justifyContent: 'space-evenly',
        alignItems: 'center',
        marginTop: '200px'
      }}
    >
      <Typography
        variant="h1"
        aria-label="Paikka"
        sx={{
          color: 'primary.main',
          textAlign: 'center'
        }}
      >
        <FormattedMessage id="page.qrcode.welcome" />
      </Typography>
    </Stack>
  )
}

export default CodePage
